import React from 'react';
import TestimonialCard from './TestimonialsCard/TestimonialCard';
import priya from '../../assets/ProfessionalsImages/Priya_Choudhary.jpg'
import krishnakant from '../../assets/ProfessionalsImages/Krishnakant_Vishwakarma.jpg'
import aman from '../../assets/ProfessionalsImages/Aman_Sharma.jpg'
import rohit from '../../assets/ProfessionalsImages/Rohit_chavan.jpg'
import mansi from '../../assets/ProfessionalsImages/Mansi_Sahu.jpg'
import palak from '../../assets/ProfessionalsImages/Palak_Agrawal.jpg'
import shrinivas from '../../assets/ProfessionalsImages/Shrinivas_Panari.jpg'

function Testimonials() {
    return (
        <>
            <div className="text-center bg-[#122b41] text-black py-28 pt-[var(--navbar-height)]">
                <h2 className="text-3xl mb-5 text-white">People love using CodeQueue</h2>
                <div className="flex justify-center flex-wrap gap-4">
                    <TestimonialCard
                      text="CodeQueue helps me grow as a mentor—each session builds my empathy, clarity, and communication."
                      authorName="Priya Choudhary"
                      authorTitle="Network Engineer"
                      imageSrc={priya}
                    />
                    <TestimonialCard
                      text="Mentoring on CodeQueue sharpens my skills and lets me give back to the tech community daily."
                      authorName="Shrinivas Panari"
                      authorTitle="Java Developer"
                      imageSrc={shrinivas}
                    />
                    <TestimonialCard
                       text="Every mentee brings new insights. CodeQueue has made me a more thoughtful and structured guide."
                       authorName="Aman Sharma"
                       authorTitle="SDE-I"
                       imageSrc={aman}
                    />
                </div>
                <div className="flex justify-center flex-wrap gap-4 mt-8">
                    <TestimonialCard
                      text="The platform is seamless, and sessions are impactful—CodeQueue fuels real-time learning for all."
                      authorName="Rohit Chavan"
                      authorTitle="Consultant"
                      imageSrc={rohit}
                    />
                    <TestimonialCard
                      text="CodeQueue lets me empower others while staying sharp and connected with industry trends"
                      authorName="Mansi Sahu"
                      authorTitle="Frontend Dev"
                      imageSrc={mansi}
                    />
                    <TestimonialCard
                       text="Being a mentor here is fulfilling—I'm growing just as much as my mentees through every session."
                       authorName="Palak Agrawal"
                       authorTitle="SDE"
                       imageSrc={palak}
                    />
                </div>
            </div>
        </>
    );
}

export default Testimonials;
